'use client';

/** Terminal header brand — shortens to just "TERMINAL" below the sm breakpoint. */
export function TerminalWordmark() {
  return (
    <span className="font-mono text-sm font-bold tracking-wider">
      <span className="hidden sm:inline text-[var(--color-text)]">EQUITYLABS </span>
      <span className="text-[var(--color-accent)]">TERMINAL</span>
    </span>
  );
}
